import { render } from "./ListDataUbahLokasi.vue?vue&type=template&id=464b4cef"
import script from "./ListDataUbahLokasi.vue?vue&type=script&lang=js"
export * from "./ListDataUbahLokasi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__